import { IonContent, IonIcon, IonPage } from '@ionic/react';
import { chevronBackOutline, people, person } from 'ionicons/icons';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import Openings from '../components/UI/Openings';
import { useRestaurant } from '../utils/contexts/restaurant-context';
import restaurantClient from '../logic/restaurant';
import formats from '../utils/formats';
import { useCart } from '../utils/contexts/cart-context';
import forms from '../utils/forms';
import Reviews from '../components/cart/Reviews';
import checkoutClient from '../logic/checkout';
import { useTracker } from '../utils/contexts/tracker-context';
import { useTranslation } from 'react-i18next';

export default function BookingRestaurantPage() {
    const history = useHistory();

    const { t } = useTranslation();
    const { restaurant } = useRestaurant();
    const { type, id } = useParams();
    const { products, quantity, total, payed } = useCart();
    const { trackDataFn } = useTracker();

    const [minDate, setMinDate] = React.useState();
    const [minTime, setMinTime] = React.useState();
    const [correctDate, setcorrectDate] = React.useState();

    function onclickHandler(e) {
        e.preventDefault();
        history.push(formats.formatUrl("/:type/q/:id/menu", { "type": "b", "id": id }));
    }

    async function submitHandler(e) {
        e.preventDefault();
        if (correctDate) {
            let finalPrice = total;
            let amount = formats.toCents(finalPrice);

            const formData = Object.fromEntries(new FormData(e.target).entries());
            let localTotal = total + (restaurant.cover_charge * formData.seats);

            const payload = {
                "customer": formData.name + " " + formData.surname,
                "note": "",
                "phone": formData.phone,
                "reserved_at": formData.reserved_at,
                "reserved_time": formData.reserved_time,
                "seats": formData.seats,
                "token": restaurant.token,
            };

            if (quantity > 0) {
                payload.order = {};
                payload.order.restaurant = {
                    "id": restaurant.id,
                    "name": restaurant.name,
                    "phone": restaurant.phone_number,
                    "token": restaurant.token,
                };
                payload.order.order = {
                    "amount": amount,
                    "commissions": "",
                    "customers": formData.seats,
                    "id": checkoutClient.randomOrderID(),
                    "number": -1,
                    "payed": payed,
                    "products": products,
                    "quantity": quantity,
                    "timestamp": Date.now(),
                    "table": "-1",
                    "total": localTotal,
                    "type": "booking",
                    "note": "",
                };
                payload.order.transaction = {
                    "id": forms.generateRandomID("pending_"),
                    "provider": "pending",
                };
            }

            try {
                const res = await restaurantClient.doPostBooking(payload);
                if (res) {
                    await trackDataFn(restaurant.id, restaurant.token, "requestbooking", { "id": restaurant.id, "seats": formData.seats }, restaurant.has_orders);

                    history.push(formats.formatUrl("/:type/q/:id/bookingcompleted", { "type": type, "id": id }));
                }
            } catch (e) {
                console.error(e);
            }
        }
    }

    React.useEffect(() => {
        function timeCheck() {
            let f = new Intl.DateTimeFormat('en');
            let a = f.formatToParts();
            setMinDate(a[4].value + "-" + getMonth(a[0].value) + "-" + a[2].value);
            setMinTime(new Date().getHours() + ":" + new Date().getMinutes());
        }

        function getMonth(month) {
            return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
        }

        timeCheck();
    }, []);

    function onChangeHandler(userTime) {
        userTime = new Date(userTime.target.value);
        if (userTime) {
            // setDate(userTime);
            let availableSlotTime = [];
            for (let day of restaurant.timetables) {
                if (formats.getDayOfWeek(day.day_of_week) === userTime.getDay()) {
                    availableSlotTime.push(day);
                }
            }
            if (availableSlotTime.length > 0) {
                setcorrectDate(true);
                return true;
            } else {
                // let index = 0;
                // for (let time of availableSlotTime) {
                //     let timeMin = new Date();
                //     let timeMax = new Date();

                //     timeMin.setMonth(userTime.getMonth());
                //     timeMin.setDate(userTime.getDate());
                //     timeMax.setMonth(userTime.getMonth());
                //     timeMax.setDate(userTime.getDate());

                //     timeMin.setHours(time.open[0] + time.open[1], time.open[3] + time.open[4], 0);
                //     timeMax.setHours(time.close[0] + time.close[1], time.close[3] + time.close[4], 0);

                //     var nextWeek = new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000);
                //     if (userTime <= nextWeek) {
                //         // if (userTime >= timeMin && userTime <= timeMax) {
                //         //     // const { hours, minutes } = formats.shiftTime(new Date(), restaurant.orders.takeaway.medium_time);
                //         //     // let minimumTakeawayTime = new Date();
                //         //     // minimumTakeawayTime.setHours(hours, minutes);
                //         //     // if (userTime >= minimumTakeawayTime) {
                //         //     //     const { hours, minutes } = formats.shiftTime(userTime, 0);
                //         //     //     // setPayload(prevState => (
                //         //     //     //     { name: prevState.name, surname: prevState.surname, street: prevState.street, time: hours + ":" + minutes, phone: prevState.phone }));

                //         //     //     // setCorrectTime(true);
                //         //     //     return true;
                //         //     // }
                //         //     return true;
                //         // }
                //         setcorrectDate(true)
                //         return true;
                //     }
                //     index = index + 1;
                // }
                // setCorrectTime(false);
                setcorrectDate(false);
                return false;
            }
        }
    }

    return (
        <IonPage>
            <IonContent>
                <div className="booking-restaurant p-4 relative overflow-y-scroll font-sans">
                    <div className="pb-4 flex pt-3 items-center">
                        <button type="button" onClick={() => history.push(formats.formatUrl("/:type/q/:id", { "type": type, "id": id }))} className="back-button absolute flex items-center justify-center p-3 rounded-full shadow-lg bg-white">
                            <IonIcon slot="icon-only" icon={chevronBackOutline}></IonIcon>
                        </button>

                        <h2 className="w-full text-center font-bold text-2xl">{t("bookingrestaurantpage.h2_1")}</h2>
                    </div>

                    <form onSubmit={submitHandler}>
                        <div className="">
                            <div className="flex py-1 justify-between items-center">
                                <div className="flex items-center">
                                    <IonIcon icon={person} className="mr-3"></IonIcon>
                                    <p className="pr-3 font-semibold">{t("bookingrestaurantpage.p_1")}</p>
                                </div>
                                <input type="text" name="name" id="name" className="w-1/2 mt-2 py-1 px-4 rounded-lg bg-grey-200" placeholder={t("bookingrestaurantpage.input.placeholder_1")} required />
                            </div>

                            <div className="flex py-1 justify-between items-center">
                                <div className="flex items-center">
                                    <IonIcon icon={person} className="mr-3"></IonIcon>
                                    <p className="pr-3 font-semibold">{t("bookingrestaurantpage.p_2")}</p>
                                </div>
                                <input type="text" name="surname" id="surname" className="w-1/2 mt-2 py-1 px-4 rounded-lg bg-grey-200" placeholder={t("bookingrestaurantpage.input.placeholder_2")} required />
                            </div>

                            <div className="flex py-6 justify-between items-center">
                                <div className="flex items-center">
                                    <IonIcon icon={people} className="mr-3"></IonIcon>
                                    <p className="pr-3 font-semibold">{t("bookingrestaurantpage.p_3")}</p>
                                </div>
                                <input type="tel" name="seats" id="seats" min="1" className="w-1/4 p-1 text-center rounded-lg  bg-grey-200" required />
                            </div>

                            <div className="py-3 flex justify-between items-center">
                                <p className="font-bold">{t("bookingrestaurantpage.p_4")}</p>
                                <input type="date" min={minDate} onChange={onChangeHandler} name="reserved_at" id="reserved_at" className="appearance-none p-1 w-2/5 h-8 text-center bg-grey-200 rounded-lg" required />
                            </div>

                            {(!correctDate) ? <p className="text-sm text-center text-red-600">{t("bookingrestaurantpage.p_5")}</p> : null}

                            <div className="py-3 flex justify-between items-center">
                                <p className="font-bold">{t("bookingrestaurantpage.p_6")}</p>
                                <input type="time" min={minTime} name="reserved_time" id="reserved_time" className="appearance-none p-1 w-2/5 h-8 text-center bg-grey-200 rounded-lg" required />
                            </div>

                            <p className="py-3 font-bold">{t("bookingrestaurantpage.p_7")}</p>
                            <Openings timetables={restaurant.timetables_formatted}></Openings>

                            <p className="pt-3 font-bold">{t("bookingrestaurantpage.p_8")}</p>
                            <div className="flex pb-3">
                                <input value="+39" className="float-left w-16 mt-2 py-1 px-2 rounded-lg bg-white" disabled />
                                <input type="tel" name="phone" id="phone" pattern="^((3[0-9][0-9]))(\d{7})$" className="float-left mt-2 py-1 px-2 rounded-lg bg-grey-200" placeholder="0000000000" required /*onChange={changeHandler}*/ />
                            </div>

                            <p className="text-sm">{t("bookingrestaurantpage.p_9")}</p>
                        </div>

                        {products.length > 0 ?
                            <div className="mt-4 border-t border-b border-black">
                                <p className="pt-4 font-bold">{t("bookingrestaurantpage.p_10")}</p>
                                <Reviews products={products}></Reviews>
                            </div> :
                            <div className="pt-8 py-6">
                                <p className="pt-4 font-bold">{t("bookingrestaurantpage.p_11")}</p>
                                <p className="text-sm">{t("bookingrestaurantpage.p_12")}</p>
                                <button onClick={onclickHandler} className="button-native w-full p-2 py-3 mt-2 rounded-lg text-black border border-mycia-red">{t("bookingrestaurantpage.button_1")}</button>
                            </div>}

                        <div className="sticky bottom-0">
                            <div className="text-xs py-4">
                                <label className="text-left break-normal">{t("bookingrestaurantpage.label_1", { restaurantName: restaurant.name })}</label>
                            </div>

                            <button type="submit" className="button-native flex items-center w-full p-2 py-3 mt-4 justify-center rounded-lg shadow-lg bg-mycia-red text-white">{t("bookingrestaurantpage.button_2")}</button>
                        </div>
                    </form>
                </div>
            </IonContent>
        </IonPage>
    );
}
